/**
 * The glob subset `.editorconfig` sections and `.prettierrc` `overrides` use:
 * `*` (not `/`), `**` (any depth), `?`, `[abc]` / `[!abc]` and `{a,b}`. A
 * pattern with no `/` matches the file's NAME anywhere below the config; one
 * with a `/` matches the path relative to the config's folder.
 */
function toRegex(glob: string): string {
  let out = ''
  let depth = 0
  for (let i = 0; i < glob.length; i++) {
    const c = glob[i]!
    if (c === '*') {
      if (glob[i + 1] === '*') {
        i++
        if (glob[i + 1] === '/') { i++; out += '(?:.*/)?' } else out += '.*'
      } else out += '[^/]*'
    } else if (c === '?') out += '[^/]'
    else if (c === '[') {
      const end = glob.indexOf(']', i + 1)
      if (end < 0) { out += '\\['; continue }
      let body = glob.slice(i + 1, end)
      if (body.startsWith('!')) body = '^' + body.slice(1)
      out += `[${body.replace(/\\/g, '\\\\')}]`
      i = end
    } else if (c === '{') { depth++; out += '(?:' }
    else if (c === '}' && depth > 0) { depth--; out += ')' }
    else if (c === ',' && depth > 0) out += '|'
    else out += c.replace(/[.+^$()|\\]/g, '\\$&')
  }
  return out
}

/** Whether `relPath` (relative to the config's folder, `/`-separated) matches `glob`. */
export function globMatches(glob: string, relPath: string): boolean {
  const pattern = glob.startsWith('/') ? glob.slice(1) : glob
  const anchored = glob.startsWith('/') || pattern.includes('/')
  const subject = anchored ? relPath : relPath.slice(relPath.lastIndexOf('/') + 1)
  try {
    return new RegExp(`^${toRegex(pattern)}$`).test(subject)
  } catch {
    return false
  }
}
